export default "__VITE_ASSET__b90a79e1__"